import React from 'react';
import { AppService } from '@aperza/util';
import { HeaderMenuButton } from './menulist/HeaderMenuButton';
import { HeaderMenuIconButton } from './menulist/HeaderMenuIconButton';
import style from './AccountFavoriteButton.module.scss';
import { HeaderPrimaryButton } from './buttons/HeaderPrimaryButton';
import { HeaderMenuList, HeaderMenuListItem } from './menulist/HeaderMenuList';
import { useAperzaUserContext } from './AperzaUserContext';
import { addUtmParam } from '../addUtmParam';
export const headerFavoriteMenuItems = [
    {
        title: 'クリップ一覧',
        url: `${AppService.accountServerHost()}/clip`,
    },
    {
        title: 'ダウンロード履歴',
        url: `${AppService.accountServerHost()}/history`,
    },
    {
        title: 'アペルザTV視聴リスト',
        url: `${AppService.tvServerHost()}/mypage/watchlist`,
    },
    {
        title: 'スキャン de カタログ一覧',
        url: `${AppService.accountServerHost()}/exhibition/contents/index.html`,
    },
];
export default function AccountFavoriteButton() {
    const { isLogin, serviceType, signUpUrl } = useAperzaUserContext();
    return (React.createElement(HeaderMenuButton, { type: "accountDropdown", header: "\u304A\u6C17\u306B\u5165\u308A", button: (isActive) => (React.createElement(HeaderMenuIconButton, { isActive: isActive, label: "\u304A\u6C17\u306B\u5165\u308A", icon: `${AppService.staticServerHost()}/common/images/header/star.svg`, iconHover: `${AppService.staticServerHost()}/common/images/header/star_red.svg` })), footer: !isLogin && (React.createElement(HeaderPrimaryButton, { buttonClassName: style.signUpButton, href: addUtmParam(signUpUrl(), 'header', serviceType), outlined: true }, "\u30A2\u30DA\u30EB\u30B6\u4F1A\u54E1\u767B\u9332\uFF08\u7121\u6599\uFF09")) },
        !isLogin && (React.createElement("div", { className: style.bodyWrapper }, "\u304A\u6C17\u306B\u5165\u308A\u6A5F\u80FD\u3092\u5229\u7528\u3059\u308B\u306B\u306F\u30ED\u30B0\u30A4\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30DA\u30EB\u30B6ID\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u304A\u5BA2\u69D8\u306F\u4EE5\u4E0B\u3088\u308A\u767B\u9332\u9858\u3044\u307E\u3059\u3002")),
        isLogin && (React.createElement(HeaderMenuList, { bordered: true }, headerFavoriteMenuItems.map((item) => (React.createElement(HeaderMenuListItem, { item: item, key: item.title.toString() })))))));
}
